import { EMPLOYMENT_INDUSTRY, TYPE_OF_EMPLOYMENT } from 'cpool-constants';
import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';
import { Anschrift } from '../Anschrift';

export const BeschaeftigungAngestellter = z.object({
    beschaeftigungsverhaeltnis: z
        .object({
            arbeitgeber: nullishDefault(
                z.object({
                    anschrift: Anschrift.omit({ wohnhaftSeit: true }),
                    branche: nullishDefault(z.nativeEnum(EMPLOYMENT_INDUSTRY)),
                    name: nullishDefault(z.string()),
                }),
            ),
            befristetBis: nullishDefault(z.coerce.date()),
            befristung: nullishDefault(z.nativeEnum(TYPE_OF_EMPLOYMENT)),
            berufsbezeichnung: nullishDefault(z.string()),
            beschaeftigtSeit: nullishDefault(z.coerce.date()),
            inProbezeit: nullishDefault(z.boolean()),
            inProbezeitBis: nullishDefault(z.coerce.date()),
            kumulierterJahreswert: nullishDefault(z.number()),
            nettoeinkommenMonatlich: nullishDefault(z.number()),
            nettoeinkommenVorletzterMonat: nullishDefault(z.number()),
            nettoeinkommenVorVorletzterMonat: nullishDefault(z.number()),
        })
        .transform((value) => {
            return {
                ...value,
                befristetBis: value.befristung === TYPE_OF_EMPLOYMENT.UNBEFRISTET ? null : value.befristetBis,
                inProbezeitBis: value.inProbezeit ? value.inProbezeitBis : null,
            };
        }),
});

export type Schema_BeschaeftigungAngestellter = z.infer<typeof BeschaeftigungAngestellter>;

// angestellter: yup
// .object()
// .shape({
//     beschaeftigungsverhaeltnis: yup.object().shape({
//         arbeitgeber: yup.object().shape({
//             anschrift: yup.object().shape({
//                 hausnummer: yup.string().optional().nullable().default(null),
//                 land: yup
//                     .string()
//                     .oneOf([
//                         'AD',
//                         'AE',
//                         'AF',
//                         'AG',
//                         'AL',
//                         'AM',
//                         'AO',
//                         'AR',
//                         'AT',
//                         'AU',
//                         'AZ',
//                         'BA',
//                         'BB',
//                         'BD',
//                         'BE',
//                         'BF',
//                         'BG',
//                         'BH',
//                         'BI',
//                         'BJ',
//                         'BN',
//                         'BO',
//                         'BR',
//                         'BS',
//                         'BT',
//                         'BW',
//                         'BY',
//                         'BZ',
//                         'CA',
//                         'CD',
//                         'CF',
//                         'CG',
//                         'CH',
//                         'CI',
//                         'CK',
//                         'CL',
//                         'CM',
//                         'CN',
//                         'CO',
//                         'CR',
//                         'XK',
//                         'CU',
//                         'CV',
//                         'CY',
//                         'CZ',
//                         'DE',
//                         'DJ',
//                         'DK',
//                         'DM',
//                         'DO',
//                         'DZ',
//                         'EC',
//                         'EE',
//                         'EG',
//                         'ER',
//                         'ES',
//                         'ET',
//                         'FI',
//                         'FJ',
//                         'FM',
//                         'FR',
//                         'GA',
//                         'GB',
//                         'GD',
//                         'GE',
//                         'GH',
//                         'GM',
//                         'GN',
//                         'GQ',
//                         'GR',
//                         'GT',
//                         'GW',
//                         'GY',
//                         'HN',
//                         'HR',
//                         'HT',
//                         'HU',
//                         'ID',
//                         'IE',
//                         'IL',
//                         'IN',
//                         'IQ',
//                         'IR',
//                         'IS',
//                         'IT',
//                         'JM',
//                         'JO',
//                         'JP',
//                         'KE',
//                         'KG',
//                         'KH',
//                         'KI',
//                         'KM',
//                         'KN',
//                         'KP',
//                         'KR',
//                         'KW',
//                         'KZ',
//                         'LA',
//                         'LB',
//                         'LC',
//                         'LI',
//                         'LK',
//                         'LR',
//                         'LS',
//                         'LT',
//                         'LU',
//                         'LV',
//                         'LY',
//                         'MA',
//                         'MC',
//                         'MD',
//                         'ME',
//                         'MG',
//                         'MH',
//                         'MK',
//                         'ML',
//                         'MM',
//                         'MN',
//                         'MR',
//                         'MT',
//                         'MU',
//                         'MV',
//                         'MW',
//                         'MX',
//                         'MY',
//                         'MZ',
//                         'NA',
//                         'NE',
//                         'NG',
//                         'NI',
//                         'NL',
//                         'NO',
//                         'NP',
//                         'NR',
//                         'NU',
//                         'NZ',
//                         'OM',
//                         'PA',
//                         'PE',
//                         'PG',
//                         'PH',
//                         'PK',
//                         'PL',
//                         'PS',
//                         'PT',
//                         'PW',
//                         'PY',
//                         'QA',
//                         'RO',
//                         'RS',
//                         'RU',
//                         'RW',
//                         'SA',
//                         'SB',
//                         'SC',
//                         'SD',
//                         'SE',
//                         'SG',
//                         'SI',
//                         'SK',
//                         'SL',
//                         'SM',
//                         'SN',
//                         'SO',
//                         'SR',
//                         'SS',
//                         'ST',
//                         'SV',
//                         'SY',
//                         'SZ',
//                         'TD',
//                         'TG',
//                         'TH',
//                         'TJ',
//                         'TL',
//                         'TM',
//                         'TN',
//                         'TO',
//                         'TR',
//                         'TT',
//                         'TV',
//                         'TZ',
//                         'UA',
//                         'UG',
//                         'US',
//                         'UY',
//                         'UZ',
//                         'VA',
//                         'VC',
//                         'VE',
//                         'VN',
//                         'VU',
//                         'WS',
//                         'YE',
//                         'ZA',
//                         'ZM',
//                         'ZW',
//                         'SONSTIGE',
//                         null,
//                     ])
//                     .optional()
//                     .nullable()
//                     .default(null),
//                 ort: yup.string().optional().nullable().default(null),
//                 plz: yup.string().optional().nullable().default(null),
//                 strasse: yup.string().optional().nullable().default(null),
//             }),
//             branche: yup
//                 .string()
//                 .oneOf([
//                     'LANDWIRTSCHAFT_FORSTWIRTSCHAFT_FISCHEREI',
//                     'ENERGIE_WASSERVERSORGUNG_BERGBAU',
//                     'VERARBEITENDES_GEWERBE',
//                     'BAUGEWERBE',
//                     'HANDEL',
//                     'VERKEHR_LOGISTIK',
//                     'INFORMATION_KOMMUNIKATION',
//                     'GEMEINNUETZIGE_ORGANISATION',
//                     'KREDITINSTITUTE_VERSICHERUNGEN',
//                     'PRIVATE_HAUSHALTE',
//                     'DIENSTLEISTUNGEN',
//                     'OEFFENTLICHER_DIENST',
//                     'GEBIETSKOERPERSCHAFTEN',
//                     'HOTEL_GASTRONOMIE',
//                     'ERZIEHUNG_UNTERRICHT',
//                     'KULTUR_SPORT_UNTERHALTUNG',
//                     'GESUNDHEIT_SOZIALWESEN',
//                     null,
//                 ])
//                 .optional()
//                 .nullable()
//                 .default(null),
//             name: yup.string().optional().nullable().default(null),
//         }),
//         befristetBis: yup.date().optional().nullable().default(null),
//         befristung: yup
//             .string()
//             .oneOf(['BEFRISTET', 'UNBEFRISTET', null])
//             .optional()
//             .nullable()
//             .default(null),
//         berufsbezeichnung: yup.string().optional().nullable().default(null),
//         beschaeftigtSeit: yup.date().optional().nullable().default(null),
//         inProbezeit: yup.boolean().optional().nullable().default(false),
//         inProbezeitBis: yup.date().optional().nullable().default(null),
//         kumulierterJahreswert: yup.number().optional().nullable().default(null),
//         nettoeinkommenMonatlich: yup.number().optional().nullable().default(null),
//         nettoeinkommenVorletzterMonat: yup.number().optional().nullable().default(null),
//         nettoeinkommenVorVorletzterMonat: yup.number().optional().nullable().default(null),
//     }),
// })
// .notRequired()
// .default(undefined)
// .when('beschaeftigungsart', {
//     is: 'ANGESTELLTER',
//     otherwise: (s) => s.strip(),
//     then: (s) => s.optional().nullable().default(null),
// }),
